import axios from "axios";

let timeoutCallbacks = null;

export const setTimeoutResetCallback = (callbacks) => {
    timeoutCallbacks = callbacks;
};

axios.interceptors.request.use(
  (config) => {
    // Pause session timeout during API calls
    if (timeoutCallbacks?.pauseTimeout) {
      timeoutCallbacks.pauseTimeout();
    }

    const token = sessionStorage.getItem("Token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }

    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    // Resume session timeout after API completes
    if (timeoutCallbacks?.resumeTimeout) {
      timeoutCallbacks.resumeTimeout();
    }
    return response;
  },
  (error) => {
    // Resume session timeout after API error
    if (timeoutCallbacks?.resumeTimeout) {
      timeoutCallbacks.resumeTimeout();
    }
    return Promise.reject(error);
  }
);
